import React from "react";
import { Tab, Tabs, Box } from "@mui/material";
import { observer } from "mobx-react";
import cn from "classnames";
import TabPanel from "@mui/lab/TabPanel";
import TabContext from "@mui/lab/TabContext";

import { IUserSettings } from "../type/type";

import { useStyles } from "./styles";

// TODO: this component is almost identical to dekstopUserSettings, follow DRY principle
const MobileUserSettings = ({
    tabSettingsContentList,
    value,
    onChange,
    appearanceTheme,
}: IUserSettings) => {
    const styles = useStyles();

    return (
        <TabContext value={value}>
            <Box
                component="div"
                className={cn(
                    styles.mobileUserSettingsWrapper,
                    appearanceTheme
                )}
            >
                <Tabs
                    className={cn(styles.tabs)}
                    value={value}
                    onChange={onChange}
                    variant="scrollable"
                >
                    {tabSettingsContentList.map((elem) => (
                        <Tab
                            key={elem.value}
                            className={cn(styles.tab)}
                            label={elem.label}
                            value={elem.value}
                            iconPosition="end"
                        />
                    ))}
                </Tabs>
                {tabSettingsContentList.map((elem) => (
                    <TabPanel
                        key={`${elem.value}_TabPanel`}
                        className={cn(
                            styles.mobileUserSettingsTabPanel,
                            appearanceTheme
                        )}
                        value={elem.value}
                    >
                        {elem.component}
                    </TabPanel>
                ))}
            </Box>
        </TabContext>
    );
};

export default observer(MobileUserSettings);
